import { render } from "./RolesSettings.vue?vue&type=template&id=545dc5ef"
import script from "./RolesSettings.vue?vue&type=script&lang=js"
export * from "./RolesSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__